import { NSFunctions } from './functions';
import { NSMessages } from './messages';

import GeoJSON from 'ol/format/GeoJSON'; 
import { MultiPoint, MultiLineString, MultiPolygon, Point, LineString, Polygon } from 'ol/geom';
import * as turf from '@turf/turf';

export let NSGeoJson = {};

NSGeoJson.init = function()
{
  NSGeoJsonPrivate.init();
  NSGeoJsonTypesPrivate.init();
  NSOpenlayersGeometryTypesPrivate.init();

  this.f_get_empty_geojson =                                  function () { return NSGeoJsonPrivate.f_get_geojson_feature_point_from_coords.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_empty_geojson_feature =                          function () { return NSGeoJsonPrivate.f_get_empty_geojson_feature.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_from_geojson_geometry =          function () { return NSGeoJsonPrivate.f_get_geojson_feature_from_geojson_geometry.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_get_geojson_feature_point_from_coords =        function () { return NSGeoJsonPrivate.f_get_geojson_feature_point_from_coords.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_point_from_wkt =           function () { return NSGeoJsonPrivate.f_get_geojson_feature_point_from_wkt.apply( NSGeoJsonPrivate, arguments ); };

  this.f_get_geojson_feature_polyline_from_coords =     function () { return NSGeoJsonPrivate.f_get_geojson_feature_polyline_from_coords.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_polyline_from_wkt =        function () { return NSGeoJsonPrivate.f_get_geojson_feature_polyline_from_wkt.apply( NSGeoJsonPrivate, arguments ); };

  this.f_get_geojson_feature_polygon_from_flatcoords =  function () { return NSGeoJsonPrivate.f_get_geojson_feature_polygon_from_flatcoords.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_polygon_from_wkt =         function () { return NSGeoJsonPrivate.f_get_geojson_feature_polygon_from_wkt.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_geojson_geometry_has_content =                 function () { return NSGeoJsonPrivate.f_geojson_geometry_has_content.apply( NSGeoJsonPrivate, arguments ); };

  this.f_get_geojson_feature_from_openlayers_render_feature =   function () { return NSGeoJsonPrivate.f_get_geojson_feature_from_openlayers_render_feature.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_shallow_copy =                     function () { return NSGeoJsonPrivate.f_get_geojson_feature_shallow_copy.apply( NSGeoJsonPrivate, arguments ); };

  this.f_get_bounds_from_geojson_geometry =                     function () { return NSGeoJsonPrivate.f_get_bounds_from_geojson_geometry.apply( NSGeoJsonPrivate, arguments ); };

  //this.f_get_empty_geojson_feature_geometry_of_type_multipolygon =        function () { return NSGeoJsonPrivate.f_get_empty_geojson_feature_geometry_of_type_multipolygon.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_geometry_of_type_multipoint_from_point =       function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_of_type_multipoint_from_point.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_geometry_of_type_multipolyline_from_polyline = function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_of_type_multipolyline_from_polyline.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_geometry_of_type_multipolygon_from_polygon =   function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_of_type_multipolygon_from_polygon.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_geometry_of_type_polygon_from_multipolygon =   function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_of_type_polygon_from_multipolygon.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_geojson_feature_geometry_is_of_type_polygon =                    function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_polygon.apply( NSGeoJsonPrivate, arguments ); };
  this.f_geojson_feature_geometry_is_of_type_multipolygon =               function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_multipolygon.apply( NSGeoJsonPrivate, arguments ); };
  this.f_geojson_feature_geometry_is_of_type_polygon_or_multipolygon =    function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_polygon_or_multipolygon.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_geojson_feature_geometry_is_of_type_polyline =                   function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_polyline.apply( NSGeoJsonPrivate, arguments ); };
  this.f_geojson_feature_geometry_is_of_type_multipolyline =              function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_multipolyline.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_geojson_feature_geometry_is_of_type_point =                      function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_point.apply( NSGeoJsonPrivate, arguments ); };
  this.f_geojson_feature_geometry_is_of_type_multipoint =                 function () { return NSGeoJsonPrivate.f_geojson_feature_geometry_is_of_type_multipoint.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_multipolyline = function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_multipolyline.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_polyline = function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_polyline.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_feature_geometry_from_array_of_geojson_feature_geometries = function () { return NSGeoJsonPrivate.f_get_geojson_feature_geometry_from_array_of_geojson_feature_geometries.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_get_geojson_union = function () { return NSGeoJsonPrivate.f_get_geojson_union.apply( NSGeoJsonPrivate, arguments ); };
  this.f_get_geojson_intersect = function () { return NSGeoJsonPrivate.f_get_geojson_intersect.apply( NSGeoJsonPrivate, arguments ); };
  
  this.f_geojson_polygon_is_valid = function () { return NSGeoJsonPrivate.f_geojson_polygon_is_valid.apply( NSGeoJsonPrivate, arguments ); };
  this.f_geojson_multi_polygon_is_valid = function () { return NSGeoJsonPrivate.f_geojson_multi_polygon_is_valid.apply( NSGeoJsonPrivate, arguments ); };

  


  //Types section
  this.Types = {};
  this.Types.CONSTS = NSGeoJsonTypesPrivate.o_geojson_types.CONSTS;

  this.Types.f_is_point =             function () { return NSGeoJsonTypesPrivate.o_geojson_types.f_is_point.apply( NSGeoJsonTypesPrivate.o_geojson_types, arguments ); };
  this.Types.f_is_polyline = 	        function () { return NSGeoJsonTypesPrivate.o_geojson_types.f_is_polyline.apply( NSGeoJsonTypesPrivate.o_geojson_types, arguments ); };
  this.Types.f_is_multipolyline =     function () { return NSGeoJsonTypesPrivate.o_geojson_types.f_is_multipolyline.apply( NSGeoJsonTypesPrivate.o_geojson_types, arguments ); };
  this.Types.f_is_polygon =           function () { return NSGeoJsonTypesPrivate.o_geojson_types.f_is_polygon.apply( NSGeoJsonTypesPrivate.o_geojson_types, arguments ); };
  this.Types.f_is_multipolygon =      function () { return NSGeoJsonTypesPrivate.o_geojson_types.f_is_multipolygon.apply( NSGeoJsonTypesPrivate.o_geojson_types, arguments ); };

    
	
	
	window.NSGeoJson_ = NSGeoJson;
	window.NSGeoJsonPrivate_ = NSGeoJsonPrivate;
  window.NSGeoJsonTypesPrivate_ = NSGeoJsonTypesPrivate;
	
}

let NSGeoJsonPrivate = {
    private_objs:
    {

    },

    init: function()
    {

    },

    f_get_empty_geojson: function()
    {
      let o_geo_json =  {
        'type': 'FeatureCollection',
        'crs': {
          'type': 'name',
          'properties': {
            'name': 'EPSG:3857',
          },
        },
        'features': []
      };
      
      return o_geo_json;
      
    },

    f_get_empty_geojson_feature: function()
    {
      let o_geojson_feature =  {
        "type": "Feature",
        "geometry": null,
        "properties": {}
      };
      
      return o_geojson_feature;
      
    },

    f_get_geojson_feature_from_geojson_geometry: function(o_geojson_feature_geometry, s_geometry_name)
    {
      let o_geojson_feature =  {
        "type": "Feature",
        "geometry": o_geojson_feature_geometry,
        "properties": {}
      };

      if(s_geometry_name != null && s_geometry_name.length > 0){
        o_geojson_feature.geometry_name = s_geometry_name;
      }
      
      return o_geojson_feature;
      
    },
    
    //a_coordinate : [x,y]
    f_get_geojson_feature_point_from_coords: function(a_coordinate)
    {
        let o_gj = {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': a_coordinate, // ex [0,0]
            },
          };

        return o_gj;  
    },
    //s_wkt:    "POINT (30 10)"
    f_get_geojson_feature_point_from_wkt: function(s_wkt)
    {
      
        let s_wkt_proc = NSFunctions.f_string_remove_all_duplicate_spaces(s_wkt);

        let a_xy = s_wkt_proc.substring(s_wkt_proc.indexOf("(")+1, s_wkt_proc.indexOf(")")).trimStart().trimEnd().split(" ");

        let o_gj = {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': a_xy, // ex [0,0]
            },
          };

        

        return o_gj;  
    },

    //a_coordinates -> [[x1,y1],[x2,y2],...]
    f_get_geojson_feature_polyline_from_coords: function(a_coordinates)
    {
        let o_gj = {
            'type': 'Feature',
            'geometry': {
              'type': 'LineString',
              /*'coordinates': [
                [4e6, -2e6],
                [8e6, 2e6],
                [9e6, 2e6],
              ],
              */
              coordinates: a_coordinates
            },
          };

        return o_gj;  
    },
    /*
        s_wkt: ex: LINESTRING (30 10, 10 30, 40 40)
    */
    f_get_geojson_feature_polyline_from_wkt: function(s_wkt)
    {
        let o_gj = {
            'type': 'Feature',
            'geometry': {
              'type': 'LineString',
              /*'coordinates': [
                [4e6, -2e6],
                [8e6, 2e6],
                [9e6, 2e6],
              ],
              */
              coordinates: null
            },
          };

        let s_wkt_proc = NSFunctions.f_string_remove_all_duplicate_spaces(s_wkt);

        let s_a_coords = s_wkt_proc.substring(s_wkt_proc.indexOf("(")+1, s_wkt_proc.indexOf(")"));
        let a_coords = s_a_coords.split(",");

        let a_coords_processed = [];
        a_coords.forEach(s_coord_i => {
            let a_coord_i = s_coord_i.trimStart().trimEnd().split(" ");
            a_coords_processed.push(a_coord_i);            
        });

        o_gj.geometry.coordinates = a_coords_processed;

        return o_gj;  
    },

    /*
        a_coordinates_flat -> [[x1,y1],[x2,y2],[x3,y3],...[x1,y1], ...]
            ->  Array of linear rings that define the polygon. 
                The first linear ring of the array defines the outer-boundary or surface of the polygon. 
                Each subsequent linear ring defines a hole in the surface of the polygon. 
                A linear ring is an array of vertices' coordinates where the first coordinate and the last are equivalent.

    */
    f_get_geojson_feature_polygon_from_flatcoords: function(a_coordinates_flat)
    {
        let o_gj = {
            'type': 'Feature',
            'geometry': {
              'type': 'Polygon',
              /*
              'coordinates': [
                [
                  [-5e6, -1e6],
                  [-4e6, 1e6],
                  [-3e6, -1e6],
                  [-5e6, -1e6],
                ],
                [
                  [-4.5e6, -0.5e6],
                  [-3.5e6, -0.5e6],
                  [-4e6, 0.5e6],
                  [-4.5e6, -0.5e6],
                ],
              ],
              */
              'coordinates': null
            },
          };

          let a_coords = [];
          let a_first_coord = null;
          a_coordinates_flat.forEach(a_coord_i => {
              if(!a_first_coord)
              {
                a_first_coord = a_coord_i;
                a_coords.push([]);
                a_coords[a_coords.length-1].push(a_coord_i);
              }
              else
              {
                a_coords[a_coords.length-1].push(a_coord_i);

                if( a_first_coord[0] == a_coord_i[0] 
                    && a_first_coord[1] == a_coord_i[1] 
                    )
                {
                    a_first_coord = null;   
                }

              }
              
          });
          
          o_gj.geometry.coordinates = a_coords;

        return o_gj;  
    },
    
    /*
    s_wkt: ex:
                POLYGON ((30 10, 40 40, 20 40, 10 20, 30 10))
                POLYGON ((35 10, 45 45, 15 40, 10 20, 35 10),
                            (20 30, 35 35, 30 20, 20 30))
    */
    f_get_geojson_feature_polygon_from_wkt: function(s_wkt)
    {
        let o_gj = {
            'type': 'Feature',
            'geometry': {
                'type': 'Polygon',
                /*
                'coordinates': [
                [
                    [-5e6, -1e6],
                    [-4e6, 1e6],
                    [-3e6, -1e6],
                    [-5e6, -1e6],
                ],
                [
                    [-4.5e6, -0.5e6],
                    [-3.5e6, -0.5e6],
                    [-4e6, 0.5e6],
                    [-4.5e6, -0.5e6],
                ],
                ],
                */
                'coordinates': null
            },
            };

            let a_coordinates_result = [];

            let s_wkt_proc = NSFunctions.f_string_remove_all_duplicate_spaces(s_wkt);

            let s_rings = s_wkt_proc.substring(s_wkt_proc.indexOf("(")+1, s_wkt_proc.lastIndexOf(")"));
            
            let s_rings_in_process = s_rings;
            while(s_rings_in_process.indexOf("(") > -1)
            {
                let s_ring_i = s_rings_in_process.substring(s_rings_in_process.indexOf("(") +1, s_rings_in_process.indexOf(")"));
                s_rings_in_process = s_rings_in_process.substring(s_rings_in_process.indexOf(")") + 1);

                let a_coords_ring_i = s_ring_i.split(",");

                let a_coords_ring_i_processed = [];
                a_coords_ring_i.forEach(s_coord_j => {
                    let a_coord_j = s_coord_j.trimStart().trimEnd().split(" ");
                    a_coords_ring_i_processed.push(a_coord_j);            
                });

                a_coordinates_result.push(a_coords_ring_i_processed);


            }
            
            
            o_gj.geometry.coordinates = a_coordinates_result;

        return o_gj;  
    },

    f_get_geojson_feature_from_openlayers_render_feature: function(o_ol_render_feature)
    {
      let o_geojson;

      let s_ol_geom_type = o_ol_render_feature.getType();

      
      if(NSOpenlayersGeometryTypesPrivate.o_ol_geom_types.f_is_point(s_ol_geom_type))
      {
        let a_cords = o_ol_render_feature.getFlatCoordinates();

        o_geojson = this.f_get_geojson_feature_point_from_coords(a_cords);
      }
      else if(NSOpenlayersGeometryTypesPrivate.o_ol_geom_types.f_is_polyline(s_ol_geom_type))
      {
        let a_cords = [];
        let a_render_flat_coords = o_ol_render_feature.getFlatCoordinates(); // [x1,y1,x2,y2,...]
        for(let i=0; i<a_render_flat_coords.length-1; i=i+2)
        {
          let coord_x = a_render_flat_coords[i];
          let coord_y = a_render_flat_coords[i+1];
          let a_coords_xy = [coord_x, coord_y];
          a_cords.push(a_coords_xy);

        }
        o_geojson = this.f_get_geojson_feature_polyline_from_coords(a_cords);
      }
      else if(NSOpenlayersGeometryTypesPrivate.o_ol_geom_types.f_is_polygon(s_ol_geom_type))
      {
        let a_cords = [];
        let a_render_flat_coords = o_ol_render_feature.getFlatCoordinates(); // [x1,y1,x2,y2,...]
        for(let i=0; i<a_render_flat_coords.length-1; i=i+2)
        {
          let coord_x = a_render_flat_coords[i];
          let coord_y = a_render_flat_coords[i+1];
          let a_coords_xy = [coord_x, coord_y];
          a_cords.push(a_coords_xy);

        }
        o_geojson = this.f_get_geojson_feature_polygon_from_flatcoords(a_cords);
      }
      //else if(NSOpenlayersGeometryTypesPrivate.o_ol_geom_types.f_is_multipolygon(s_ol_geom_type))

      return o_geojson;
    },

    f_get_geojson_feature_shallow_copy: function(o_geo_json_feature_in)
    {
      let o_geojson_shallow_copy = Object.assign( {}, o_geo_json_feature_in );

      return o_geojson_shallow_copy;
    },


    f_geojson_geometry_has_content: function (o_geojson_feature_geometry)
    {
    
      let b_res = false;
    
      let o_geojson_types = NSGeoJsonTypesPrivate.o_geojson_types;
      
      
      if (o_geojson_feature_geometry == null)
      {
        b_res = false;
        return b_res;
      }
      
      let a_coords = o_geojson_feature_geometry.coordinates;
      let s_geometry_type = o_geojson_feature_geometry.type;
      if( o_geojson_types.f_is_point(s_geometry_type) )
      {
        
        if(a_coords != null && a_coords.length>0)
        {
          b_res = true;
        }
        else
        {
          b_res = false;
        }
        
      }
      else if( o_geojson_types.f_is_polyline(s_geometry_type) )
      {
        if(a_coords != null && a_coords.length>0)
        {
          b_res = true;
        }
        else
        {
          b_res = false;
        }
        
      }
      else if( o_geojson_types.f_is_polygon(s_geometry_type) )
      {
        if(a_coords != null && a_coords.length>0)
        {
          b_res = true;
        }
        else
        {
          b_res = false;
        }
      }
      else if( o_geojson_types.f_is_multipolygon(s_geometry_type) )
      {
        if(a_coords != null && a_coords.length>0)
        {
          b_res = true;
        }
        else
        {
          b_res = false;
        }
      }
      else if( o_geojson_types.f_is_multipolyline(s_geometry_type) )
      {
        if(a_coords != null && a_coords.length>0)
        {
          b_res = true;
        }
        else
        {
          b_res = false;
        }
      }
      else if( o_geojson_types.f_is_multipoint(s_geometry_type) )
      {
        if(a_coords != null && a_coords.length>0)
        {
          b_res = true;
        }
        else
        {
          b_res = false;
        }
      }
      else
      {
        //alert("Geometry type not recognized!");
        console.log("NSGeoJson - Geometry type not recognized!");
      }
      
      return b_res;
    },

    f_get_bounds_from_geojson_geometry : function(o_geojson_feature_geometry)
    {

      let o_geojson_types = NSGeoJsonTypesPrivate.o_geojson_types;
      
      let b_gj_geom_has_content = this.f_geojson_geometry_has_content(o_geojson_feature_geometry);
      if(!b_gj_geom_has_content)
      {
        return null;
      }


      let b_bounds_values_initialized = false;
      let x_min, y_min, x_max, y_max;
      
      let f_init_bounds_values = function(a_point)
      {
        x_min = a_point[0];
        y_min = a_point[1];
        x_max = a_point[0];
        y_max = a_point[1];   
      }

      let f_update_bounds_values_with_array = function(a_input)
      {
        if(!b_bounds_values_initialized)
        {
          f_init_bounds_values(a_input[0]);
          b_bounds_values_initialized = true;
        }
        
        a_input.forEach(a_coords_elem => {
          x_min = (a_coords_elem[0] < x_min) ? a_coords_elem[0] : x_min;
          y_min = (a_coords_elem[1] < y_min) ? a_coords_elem[1] : y_min;
          x_max = (a_coords_elem[0] > x_max) ? a_coords_elem[0] : x_max;
          y_max = (a_coords_elem[1] > y_max) ? a_coords_elem[1] : y_max;
        });
      }
      
      let a_coords = o_geojson_feature_geometry.coordinates;
      let s_geometry_type = o_geojson_feature_geometry.type;
      if( o_geojson_types.f_is_point(s_geometry_type) )
      {
        x_min = a_coords[0];
        y_min = a_coords[1];
        x_max = a_coords[0];
        y_max = a_coords[1];        
      }
      else if( o_geojson_types.f_is_polyline(s_geometry_type) )
      {
        f_update_bounds_values_with_array(a_coords);        
      }
      else if( o_geojson_types.f_is_polygon(s_geometry_type) )
      {
        a_coords.forEach(a_coords_list_i => {
          f_update_bounds_values_with_array(a_coords_list_i);   
        });
        
      }
      else if( o_geojson_types.f_is_multipolygon(s_geometry_type) )
      {
        a_coords.forEach(a_coords_list_i => {
          a_coords_list_i.forEach(a_coords_list_j => {
            f_update_bounds_values_with_array(a_coords_list_j);   
          });
        });
        
        
      }
      else if( o_geojson_types.f_is_multipolyline(s_geometry_type) )
      {
        a_coords.forEach(a_coords_list_i => {
          f_update_bounds_values_with_array(a_coords_list_i);   
        });
        
        
      }
      else if( o_geojson_types.f_is_multipoint(s_geometry_type) )
      {
        f_update_bounds_values_with_array(a_coords);        
      }
      else
      {
        alert("Geometry type not recognized!");
        return null;
      }

      return [x_min, y_min, x_max, y_max];

    },

    
    f_get_empty_geojson_feature_geometry_of_type_multipoint: function()
    {
      let s_type = NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.multipoint;
      let o_gj = {
          'type': 'Feature',
          'geometry': {
            'type': s_type,
            /*
            'coordinates': [
              ...
            ],
            */
            'coordinates': []//;null
          },
        };

      return o_gj.geometry;
    },

    f_get_empty_geojson_feature_geometry_of_type_multipolyline: function()
    {
      let s_type = NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.multipolyline;
      let o_gj = {
          'type': 'Feature',
          'geometry': {
            'type': s_type,
            /*
            'coordinates': [
              ...
            ],
            */
            'coordinates': []//;null
          },
        };

      return o_gj.geometry;
    },
    
    f_get_empty_geojson_feature_geometry_of_type_multipolygon: function()
    {
      let s_type = NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.multipolygon;
      let o_gj = {
          'type': 'Feature',
          'geometry': {
            'type': s_type,
            /*
            'coordinates': [
              ...
            ],
            */
            'coordinates': []//;null
          },
        };

      return o_gj.geometry;
    },
    f_get_empty_geojson_feature_geometry_of_type_polygon: function()
    {
      let s_type = NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.polygon;
      let o_gj = {
          'type': 'Feature',
          'geometry': {
            'type': s_type,
            /*
            'coordinates': [
              ...
            ],
            */
            'coordinates': []//;null
          },
        };

      return o_gj.geometry;
    },

    f_get_geojson_feature_geometry_of_type_multipoint_from_point: function(o_geojson_feature_geometry_point)
    {
      let o_geojson_feature_geometry_multipoint = null;

      if(o_geojson_feature_geometry_point != null)
      {
        o_geojson_feature_geometry_multipoint = this.f_get_empty_geojson_feature_geometry_of_type_multipoint();
        o_geojson_feature_geometry_multipoint.coordinates.push(o_geojson_feature_geometry_point.coordinates);
      }
      return o_geojson_feature_geometry_multipoint;
      
    },

    f_get_geojson_feature_geometry_of_type_multipolyline_from_polyline: function(o_geojson_feature_geometry_polyline)
    {
      let o_geojson_feature_geometry_multipolyline = null;

      if(o_geojson_feature_geometry_polyline != null)
      {
        o_geojson_feature_geometry_multipolyline = this.f_get_empty_geojson_feature_geometry_of_type_multipolyline();
        o_geojson_feature_geometry_multipolyline.coordinates.push(o_geojson_feature_geometry_polyline.coordinates);
      }
      return o_geojson_feature_geometry_multipolyline;
      
    },

    f_get_geojson_feature_geometry_of_type_multipolygon_from_polygon: function(o_geojson_feature_geometry_polygon)
    {
      let o_geojson_feature_geometry_multipolygon = null;

      if(o_geojson_feature_geometry_polygon != null)
      {
        o_geojson_feature_geometry_multipolygon = this.f_get_empty_geojson_feature_geometry_of_type_multipolygon();
        o_geojson_feature_geometry_multipolygon.coordinates.push(o_geojson_feature_geometry_polygon.coordinates);
      }
      return o_geojson_feature_geometry_multipolygon;
      
    },
    /**
     * 
     * @param {*} o_geojson_feature_geometry_multipolygon geometry of the type multipolygon from a geojson object
     * @returns A GeoJSON geometry of type Polygon created from a Multipolygon where only the first geomoetry in the multipolygon is used.
     */
    f_get_geojson_feature_geometry_of_type_polygon_from_multipolygon: function(o_geojson_feature_geometry_multipolygon)
    {
      let o_geojson_feature_geometry_polygon = null;

      if(o_geojson_feature_geometry_multipolygon != null)
      {
        o_geojson_feature_geometry_polygon = this.f_get_empty_geojson_feature_geometry_of_type_polygon();
        
        //only the first geomoetry in the multipolygon is used.
        o_geojson_feature_geometry_polygon.coordinates = (o_geojson_feature_geometry_multipolygon.coordinates[0]);
      }

      return o_geojson_feature_geometry_polygon;

    },

    f_geojson_feature_geometry_is_of_type_polygon: function(o_geojson_feature_geometry)
    {
      return o_geojson_feature_geometry.type == NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.polygon;
      
    },
    f_geojson_feature_geometry_is_of_type_multipolygon: function(o_geojson_feature_geometry)
    {
      return o_geojson_feature_geometry.type == NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.multipolygon;
      
    },
    f_geojson_feature_geometry_is_of_type_polygon_or_multipolygon: function(o_geojson_feature_geometry)
    {
      return ( this.f_geojson_feature_geometry_is_of_type_polygon(o_geojson_feature_geometry)
              || this.f_geojson_feature_geometry_is_of_type_multipolygon(o_geojson_feature_geometry) );
    },

    f_geojson_feature_geometry_is_of_type_polyline: function(o_geojson_feature_geometry)
    {
      return o_geojson_feature_geometry.type == NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.polyline;
      
    },
    f_geojson_feature_geometry_is_of_type_multipolyline: function(o_geojson_feature_geometry)
    {
      return o_geojson_feature_geometry.type == NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.multipolyline;
      
    },
    f_geojson_feature_geometry_is_of_type_point: function(o_geojson_feature_geometry)
    {
      return o_geojson_feature_geometry.type == NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.point;
      
    },
    f_geojson_feature_geometry_is_of_type_multipoint: function(o_geojson_feature_geometry)
    {
      return o_geojson_feature_geometry.type == NSGeoJsonTypesPrivate.o_geojson_types.CONSTS.multipoint;
      
    },

    f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_multipolyline: function(a_geojson_feature_geometry_multipolyline)
    {
        let o_geojson_feature_geometry_multipolygon = 
          {
              type: 'MultiLineString', coordinates: []
          };
        a_geojson_feature_geometry_multipolyline.forEach( o_i => {
          o_geojson_feature_geometry_multipolygon.coordinates = o_geojson_feature_geometry_multipolygon.coordinates.concat(o_i.coordinates);
        } );

        return o_geojson_feature_geometry_multipolygon;

    },

    f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_polyline: function(a_geojson_feature_geometry_polyline)
    {
        let o_geojson_feature_geometry_multipolygon = 
          {
              type: 'MultiLineString', coordinates: []
          };

        // Each o_i is a of type LineString
        a_geojson_feature_geometry_polyline.forEach( o_i => {
          o_geojson_feature_geometry_multipolygon.coordinates.push(o_i.coordinates);
        } );

        return o_geojson_feature_geometry_multipolygon;

    },

    f_get_geojson_feature_geometry_from_array_of_geojson_feature_geometries: function(a_geojson_feature_geometry)
    {
        let o_geometry_0 = (a_geojson_feature_geometry.length > 0)? a_geojson_feature_geometry[0]: null;
        if (o_geometry_0 != null)
        {
          let o_geojson_types = NSGeoJsonTypesPrivate.o_geojson_types;
          if(o_geometry_0.type == o_geojson_types.CONSTS.multipolyline) // geojson geometry of type "MultiLineString"
          {
            return this.f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_multipolyline(a_geojson_feature_geometry);
          }
          else if(o_geometry_0.type == o_geojson_types.CONSTS.polyline) // geojson geometry of type "LineString"
          {
            return this.f_get_geojson_feature_geometry_of_type_multipolyline_from_array_of_polyline(a_geojson_feature_geometry);
          }
          else
          {
            console.error("NSGeoJson - f_get_geojson_feature_geometry_from_array_of_geojson_feature_geometries - function has no implementations for geometry type");
            return null;
          }
        }
        else 
        {
          return null;
        }

        let o_geojson_feature_geometry_multipolygon = 
          {
              type: 'MultiLineString', coordinates: []
          };
        a_geojson_feature_geometry_multipolyline.forEach( o_i => {
          o_geojson_feature_geometry_multipolygon.coordinates = o_geojson_feature_geometry_multipolygon.coordinates.concat(o_i.coordinates);
        } );

        return o_geojson_feature_geometry_multipolygon;

    },
    
    f_get_geojson_union(base_gj, gj_to_add)
    {
      const geojsonFormat = new GeoJSON();
      let baseGeometry = geojsonFormat.readGeometry(base_gj);
      let newGeometry = geojsonFormat.readGeometry(gj_to_add);
  
      // Promote single geometries to their multi counterparts if necessary
      if (baseGeometry instanceof Point) {
          baseGeometry = new MultiPoint([baseGeometry.getCoordinates()]);
      } else if (baseGeometry instanceof LineString) {
          baseGeometry = new MultiLineString([baseGeometry.getCoordinates()]);
      } else if (baseGeometry instanceof Polygon) {
          baseGeometry = new MultiPolygon([baseGeometry.getCoordinates()]);
      }
  
      if (newGeometry instanceof Point) {
          newGeometry = new MultiPoint([newGeometry.getCoordinates()]);
      } else if (newGeometry instanceof LineString) {
          newGeometry = new MultiLineString([newGeometry.getCoordinates()]);
      } else if (newGeometry instanceof Polygon) {
          newGeometry = new MultiPolygon([newGeometry.getCoordinates()]);
      }
  
      // Append new geometry elements to the base geometry
      if (baseGeometry instanceof MultiPoint && newGeometry instanceof MultiPoint) {
          newGeometry.getPoints().forEach(point => baseGeometry.appendPoint(point));
      } else if (baseGeometry instanceof MultiLineString && newGeometry instanceof MultiLineString) {
          newGeometry.getLineStrings().forEach(line => baseGeometry.appendLineString(line));
      } else if (baseGeometry instanceof MultiPolygon && newGeometry instanceof MultiPolygon) {
          newGeometry.getPolygons().forEach(polygon => baseGeometry.appendPolygon(polygon));
      } else {
          //throw new Error('Invalid geometry types');
          
          /*let s_message = "Geometria inválida, operação cancelada!";
				  NSMessages.f_show_information( s_message + " "  , 5000);
          return base_gj;*/
          return null;  // error
      }
  
      const updatedGeoJSON = geojsonFormat.writeGeometryObject(baseGeometry);
      return updatedGeoJSON;
      
    },
    /**
     * @description check if point is inside poligon and not it's holes
     */
    f_ol_point_is_inside_polygon_and_not_its_holes(ol_polygon, ol_point)
    {
      // check if ol_point intersects with polygon_i
      const outerBoundary = new Polygon([ol_polygon.getLinearRing(0).getCoordinates()]);
      // Check if ol_point is inside outerBoundary and not inside any holes
      let insideOuterBoundary = outerBoundary.intersectsCoordinate(ol_point);
      let insideHole = false;

      const linearRingsCount = ol_polygon.getLinearRingCount();
      if (insideOuterBoundary && linearRingsCount > 1) {
        for (let k = 1; k < linearRingsCount; k++) {
            const holeBoundary = new Polygon([ol_polygon.getLinearRing(k).getCoordinates()]);
            if (holeBoundary.intersectsCoordinate(ol_point)) {
                insideHole = true;
                break;
            }
        }
      }

      return (insideOuterBoundary && !insideHole);

    },


    f_geojson_multi_polygon_is_valid(gjMultiPolygon)
    {
      // Parse the GeoJSON using OpenLayers
      const geojsonFormat = new GeoJSON();
      let ol_multi_polygon = geojsonFormat.readGeometry(gjMultiPolygon);

      let b_multi_polygon_is_valid = false;

      if (!ol_multi_polygon instanceof MultiPolygon) {
        throw new Error('ol_multi_polygon must be a MultiPolygon.');
      }

      
      // seems that this is a deep copy, at the content of baseMultiPolygon must be reset
      let a_polygons = ol_multi_polygon.getPolygons(); 

      for(let i=0; i<a_polygons.length; i++)
      {
        let polygon_i = a_polygons[i];  // Polygon

        // Write the updated MultiPolygon back to GeoJSON
        const polygonIGeoJSON = geojsonFormat.writeGeometryObject(polygon_i);
        let b_polygon_is_valid = this.f_geojson_polygon_is_valid(polygonIGeoJSON);

        if (!b_polygon_is_valid) {
          b_multi_polygon_is_valid = false;
          return b_multi_polygon_is_valid;
        }

        // checking if there are no interesection between polygons in the multipolygon
        for(let j=0; j<a_polygons.length; j++)
        {
          if(i != j) // to avoid an polygon check against itself
          {
            let polygon_j = a_polygons[j];  // Polygon
            let b_polygons_intersect = this.f_b_ol_polygons_intersect(polygon_i, polygon_j);
            if (b_polygons_intersect) // polygons can't intersect
            {
              b_multi_polygon_is_valid = false;
              return b_multi_polygon_is_valid;
            }
          }
        }

      }

      b_multi_polygon_is_valid = true;
      return b_multi_polygon_is_valid;

    },

    f_geojson_polygon_is_valid(gjPolygon)
    {
      
      // Parse the GeoJSON using OpenLayers
      const geojsonFormat = new GeoJSON();
      
      let b_polygon_is_valid = false;

      let ol_polygon = geojsonFormat.readGeometry(gjPolygon);


      if (!ol_polygon instanceof Polygon) {
        throw new Error('ol_polygon must be a Polygon.');
      }

      const outerBoundary = new Polygon([ol_polygon.getLinearRing(0).getCoordinates()]);

      let linearRingsCount = ol_polygon.getLinearRingCount();
      for (let i = 1; i < linearRingsCount; i++) // for each hole
      {
        const holeBoundary_i = new Polygon([ol_polygon.getLinearRing(i).getCoordinates()]);

        // all holes must be inside outerBoundary
        let b_inside = this.f_b_ol_polygon1_contains_ol_polygon2(outerBoundary, holeBoundary_i)
        if (!b_inside)
        {
          b_polygon_is_valid = false;
          return b_polygon_is_valid;
        }

        for(let j=2; j < linearRingsCount; j++) // start on 2 because 1 shouldn't be checked against itself
        {
          if(i != j) // to avoid an hole check against itself
          {
            const holeBoundary_j = new Polygon([ol_polygon.getLinearRing(j).getCoordinates()]);
            let b_holes_intersect = this.f_b_ol_polygons_intersect(holeBoundary_i, holeBoundary_j);
            if (b_holes_intersect) // holes can't intersect
            {
              b_polygon_is_valid = false;
              return b_polygon_is_valid;
            }
          }
        }       
      }
      b_polygon_is_valid = true;
      return b_polygon_is_valid;

    },

    /**
     * @description uses turf API - do detect any intersection between two polygons
     */
    f_b_ol_polygons_intersect(ol_polygon1, ol_polygon2)
    {
      const polygon1 = ol_polygon1; 
      const polygon2 = ol_polygon2; 
      
      // Parse the GeoJSON using OpenLayers
      const geojsonFormat = new GeoJSON();
      // Convert OpenLayers geometries to GeoJSON 
      const polygon1GeoJSON = geojsonFormat.writeGeometryObject(polygon1); 
      const polygon2GeoJSON = geojsonFormat.writeGeometryObject(polygon2); 
      // Check if polygons overlap using turf.js 
      let b_inytersects = turf.booleanIntersects(polygon1GeoJSON, polygon2GeoJSON);
      return b_inytersects;
    },
    /**
     * @description uses turf API - do detect any intersection between two polygons
     */
    f_b_ol_polygon1_contains_ol_polygon2(ol_polygon1, ol_polygon2)
    {
      const polygon1 = ol_polygon1; 
      const polygon2 = ol_polygon2; 
      
      // Parse the GeoJSON using OpenLayers
      const geojsonFormat = new GeoJSON();
      // Convert OpenLayers geometries to GeoJSON 
      const polygon1GeoJSON = geojsonFormat.writeGeometryObject(polygon1); 
      const polygon2GeoJSON = geojsonFormat.writeGeometryObject(polygon2); 
      // Check if polygons overlap using turf.js 
      let b_inytersects = turf.booleanContains(polygon1GeoJSON, polygon2GeoJSON);
      return b_inytersects;
    },

    f_ol_polygon_is_fully_inside_ol_polygon_and_not_its_holes(ol_outer_polygon, ol_inner_polygon)
    {
      let outerPolygon = ol_outer_polygon;
      let holePolygon = ol_inner_polygon;

      let b_polygon_is_inside_outer_polygon = true;

      if (!(outerPolygon instanceof Polygon) || !(holePolygon instanceof Polygon)) {
        throw new Error('outerPolygon must be a Polygon and holePolygon must be a Polygon.');
      }
      
      
      // below check if ol_inner_polygon is inside ol_outer_polygon
      let a_outer_ring_coords = holePolygon.getCoordinates()[0];
      for(let i=0; i<a_outer_ring_coords.length; i++)
      {
        let holePoint = a_outer_ring_coords[i];
        let b_point_is_inside = this.f_ol_point_is_inside_polygon_and_not_its_holes(outerPolygon, holePoint);
        if(!b_point_is_inside)
        {
          b_polygon_is_inside_outer_polygon = false;
          break;
        }
      }
      if(!b_polygon_is_inside_outer_polygon)
      {
        return b_polygon_is_inside_outer_polygon;
      }

      // checking if new hole has no intersections with ol_outer_polygon holes - it would result in an invalid geometry
      let linearRingsCount = outerPolygon.getLinearRingCount();
      for (let k = 1; k < linearRingsCount; k++) // for each hole
      {
        const outerPolygonHoleBoundary_k = new Polygon([outerPolygon.getLinearRing(k).getCoordinates()]);
        let b_intersects = this.f_b_ol_polygons_intersect(outerPolygonHoleBoundary_k, holePolygon);
        if(b_intersects) // there's an intersection between an ol_outer_polygon's hole and new hole
        {
          b_polygon_is_inside_outer_polygon = false;
          break;
        }
        
      }

      return b_polygon_is_inside_outer_polygon;
    },

    f_get_geojson_intersect(gj_base, gj_hole)
    {
      // Parse the GeoJSON using OpenLayers
      const geojsonFormat = new GeoJSON();

      let o_geojson_types = NSGeoJsonTypesPrivate.o_geojson_types;
            
      let s_base_geometry_type = gj_base.type;
      let s_hole_geometry_type = gj_hole.type;
      if( o_geojson_types.f_is_polygon(s_base_geometry_type) && o_geojson_types.f_is_polygon(s_hole_geometry_type) )
      {

        let basePolygon = geojsonFormat.readGeometry(gj_base);
        const holePolygon = geojsonFormat.readGeometry(gj_hole);

        if (!(basePolygon instanceof Polygon) || !(holePolygon instanceof Polygon)) {
          throw new Error('Base must be a Polygon and Hole must be a Polygon.');
        }

        basePolygon.appendLinearRing(holePolygon.getLinearRing(0)); // Assuming the hole is the outer ring of the Polygon

        // Write the updated MultiPolygon back to GeoJSON
        const updatedPolygonGeoJSON = geojsonFormat.writeGeometryObject(basePolygon);

        
        let b_is_valid = this.f_geojson_polygon_is_valid(updatedPolygonGeoJSON);
        if(!b_is_valid)
        {
          //throw new Error('Calculated polygon is not valid!');
          /*let s_message = "Geometria inválida, operação cancelada!";
				  NSMessages.f_show_information( s_message + " "  , 5000);
          return gj_base;*/
          return null;  // error
        }

        return updatedPolygonGeoJSON;

      }
      else if( o_geojson_types.f_is_multipolygon(s_base_geometry_type) 
              && (  o_geojson_types.f_is_polygon(s_hole_geometry_type) 
                    || o_geojson_types.f_is_multipolygon(s_hole_geometry_type) )
      )
      {        
        let baseMultiPolygon = geojsonFormat.readGeometry(gj_base);
        let holePolygonValue;
        if(o_geojson_types.f_is_polygon(s_hole_geometry_type))
        {
          holePolygonValue = geojsonFormat.readGeometry(gj_hole);
        }
        else // o_geojson_types.f_is_multipolygon(s_hole_geometry_type)
        {          
          const holeMultiPolygon = geojsonFormat.readGeometry(gj_hole);
          holePolygonValue = holeMultiPolygon.getPolygon(0); // firs polygon will be the hole
        }
        const holePolygon = holePolygonValue;
           
        if (!(baseMultiPolygon instanceof MultiPolygon) || !(holePolygon instanceof Polygon)) {
          throw new Error('Base must be a MultiPolygon and hole must be a Polygon.');
        }

        let targetPolygon = null;

        // seems that this is a deep copy, at the content of baseMultiPolygon must be reset
        let a_polygons = baseMultiPolygon.getPolygons(); 

        for(let i=0; i<a_polygons.length; i++)
        {
          let polygon_i = a_polygons[i];  // Polygon

          let b_holeInsidePolygon = this.f_ol_polygon_is_fully_inside_ol_polygon_and_not_its_holes(polygon_i, holePolygon)
          
          if (b_holeInsidePolygon) {
            targetPolygon = polygon_i;
            break;
          }

        }

        // If no containing polygon is found, throw an error
        if (!targetPolygon) {
          //throw new Error('No containing polygon found for the hole.');
          /*let s_message = "Geometria inválida, operação cancelada!";
				  NSMessages.f_show_information( s_message + " "  , 5000);
          return gj_base;*/
          return null;  // error
        }
        
        targetPolygon.appendLinearRing(holePolygon.getLinearRing(0)); // Assuming the hole is the outer ring of the Polygon

        let newMultiPolygonCoords = a_polygons.map( polygon => polygon.getCoordinates() );
        baseMultiPolygon.setCoordinates(newMultiPolygonCoords);
    
        // Write the updated MultiPolygon back to GeoJSON
        const updatedMultiPolygonGeoJSON = geojsonFormat.writeGeometryObject(baseMultiPolygon);

        let b_is_valid = this.f_geojson_multi_polygon_is_valid(updatedMultiPolygonGeoJSON);
        if(!b_is_valid)
        {
          //throw new Error('Calculated multi_polygon is not valid!');
          /*let s_message = "Geometria inválida, operação cancelada!";
				  NSMessages.f_show_information( s_message + " "  , 5000);
          return gj_base;*/
          return null;  // error
        }

        return updatedMultiPolygonGeoJSON;

      }
      

      //throw new Error('Geometria inválida, operação cancelada!');
      /*let s_message = "Geometria inválida, operação cancelada!";
      NSMessages.f_show_information( s_message + " "  , 5000);
      return gj_base;*/
      return null;  // error

    }

};


let NSGeoJsonTypesPrivate = {
	
	o_geojson_types:
	{
        CONSTS:
        {
            point: "Point",
            polyline: "LineString",
            polygon: "Polygon",
            multipoint: "MultiPoint",
            multipolygon: "MultiPolygon",
            multipolyline: "MultiLineString"
        },

		f_is_point: function(s_geometry_type)
		{
			var b_ = (s_geometry_type == this.CONSTS.point)? true : false;
			return b_;
		},
		f_is_polyline: function(s_geometry_type)
		{
			var b_ = (s_geometry_type == this.CONSTS.polyline)? true : false;
			return b_;
		},
		f_is_polygon: function(s_geometry_type)
		{
			var b_ = (s_geometry_type == this.CONSTS.polygon)? true : false;
			return b_;
		},
		f_is_multipolygon: function(s_geometry_type)
		{
			var b_ = (s_geometry_type == this.CONSTS.multipolygon)? true : false;
			return b_;
		},
		f_is_multipolyline: function(s_geometry_type)
		{
			var b_ = (s_geometry_type == this.CONSTS.multipolyline)? true : false;
			return b_;
		},
		f_is_multipoint: function(s_geometry_type)
		{
			var b_ = (s_geometry_type == this.CONSTS.multipoint)? true : false;
			return b_;
		}
	},
		
  init: function()
  {

  }
	
}

let NSOpenlayersGeometryTypesPrivate = {
	
  o_ol_geom_types:
  {
        CONSTS:
        {
          /*
            POINT 	string 	Point 	
            LINE_STRING 	string 	LineString 	
            LINEAR_RING 	string 	LinearRing 	
            POLYGON 	string 	Polygon 	
            MULTI_POINT 	string 	MultiPoint 	
            MULTI_LINE_STRING 	string 	MultiLineString 	
            MULTI_POLYGON 	string 	MultiPolygon 	
            GEOMETRY_COLLECTION 	string 	GeometryCollection 	
            CIRCLE 	string 	Circle 
          */
            point: "Point",
            polyline: "LINE_STRING",
            polygon: "Polygon",
            multipolygon: "MULTI_POLYGON",
        },

    f_is_point: function(s_geometry_type)
    {
      var b_ = (s_geometry_type == this.CONSTS.point)? true : false;
      return b_;
    },
    f_is_polyline: function(s_geometry_type)
    {
      var b_ = (s_geometry_type == this.CONSTS.polyline)? true : false;
      return b_;
    },
    f_is_polygon: function(s_geometry_type)
    {
      var b_ = (s_geometry_type == this.CONSTS.polygon)? true : false;
      return b_;
    },
    f_is_multipolygon: function(s_geometry_type)
    {
      var b_ = (s_geometry_type == this.CONSTS.multipolygon)? true : false;
      return b_;
    },
  },
		
  init: function()
  {

  }
	
}